import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable, take } from 'rxjs';
import { DuplicatePopupResult } from 'src/app/features/components/accounts-payable/accounts-payable.model';
import { MessagePopupComponent } from '../components/message-popup/message-popup.component';
import { ModalPopupMessages, popupWidth } from '../utility/constants';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private openedPopcount = 0;

  constructor(
    private readonly dialog: MatDialog,
    private readonly commonService: CommonService
  ) {}

  public openPopup(
    code: any,
    title: any,
    component: any,
    width: string,
    injectedComponent?: any
  ) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = width; // Dynamically set the width
    dialogConfig.data = {
      title: title,
      code: code,
      injectedComponent: injectedComponent,
    };

    // does not let Modal auto-close on backdrop click
    dialogConfig.disableClose = true;
    const dialogRef = this.dialog.open(component, dialogConfig);
    dialogRef
      .afterOpened()
      .pipe(take(1))
      .subscribe(() => {
        this.commonService.setOverlayOpen(true);
        this.openedPopcount++;
      });
    dialogRef
      .afterClosed()
      .pipe(take(1))
      .subscribe(() => {
        this.openedPopcount--;
        if (this.openedPopcount === 0) {
          this.commonService.setOverlayOpen(false);
        }
      });
    return dialogRef;
  }

  public openDuplicatePopup(
    duplicateDetails: unknown,
    message: string
  ): Observable<DuplicatePopupResult | undefined> {
    return this.openPopup(
      {
        message,
        isFooterRequired: true,
        duplicateDetails,
        isApChargeDuplicateEntry: true,
      },
      ModalPopupMessages.APShipmentDuplicateEntry,
      MessagePopupComponent,
      popupWidth.existingAccountsPopup
    ).afterClosed();
  }
}
